import InstrumentRow from './InstrumentRow';

// eslint-disable-next-line import/prefer-default-export
export { InstrumentRow };
